

<template>
  <div class="page4">
     <div class="h90"></div>
     <div class="content">
        <div class="title1" :class="{'ani_top': ani_top}">{{msg}}</div>
        <div class="title2">WEB、IOS、Android、HTML5、PAD</div>
        <div class="list">
            <ul>
                <li>
                    <img :src="url + '/assets/icon-web.png'">
                </li>
               <li>
                    <img :src="url + '/assets/icon-notebook.png'">
                </li>
                <li>
                    <img :src="url + '/assets/icon-pad.png'">
                </li>
                <li class="none">
                    <img :src="url + '/assets/icon-phone.png'">
                </li>
            </ul>
        </div>
        <div class="title3">以成熟的JAVA、HTML5为基础，实现不同终端自适应的系统体验</div>
     </div>
  </div>
</template>
<script>
import defaultSettings from '@/defaultSettings'
export default {
  name: 'page2',
  data() {
    return {
        url: defaultSettings.url,
        msg: ''
    }
  },
  props:{
    ani_top: {
        type: [Boolean],
        require: false,
        default: false,
    },
  },
  watch: {
    ani_top (value) {
        if (value) {
            return this.msg = '高端系统设计专家'
        } else {
            this.msg = ''
        }
    }
  },
  created() {},
  mounted() {
  },
  methods: {
  }
};
</script>
<style lang="less" scoped>
.page4 {
    margin:0 auto;
    text-align: center;
    .h90{
        height:90px;
    }
    .content{
        width:1200px;
        margin:0 auto;
        .title1{
            height:100px;
            margin-top:25vh;
            font-size: 60px;
            font-weight: bold;
            color: #333;
        }
        .title2{       
            font-size: 28px;
            color: #333;
            margin-top:34px;
        }
        .iCloud{
            margin-top:90px;
            font-size: 32.5px;
            color:#333;
            img{
                width:74px;
                height:80px;
                vertical-align: middle;
            }
        }
        .list{
            margin-top:40px;
            ul {
                li{
                    display: inline-block;
                    margin-right:50px;
                    img{
                        width:88px;
                        height:88px;
                    }
                }
                .none{
                   margin-right:0px;
                }
            }
        }
        .title3{
          font-size: 20px;
          color: #333;
          margin-top:45px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/page4.vue